import { render, staticRenderFns } from "./TabellaFaseStandardNew.vue?vue&type=template&id=3e864b1c&"
import script from "./TabellaFaseStandardNew.vue?vue&type=script&lang=js&"
export * from "./TabellaFaseStandardNew.vue?vue&type=script&lang=js&"
import style0 from "./TabellaFaseStandardNew.vue?vue&type=style&index=0&css=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports